import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import FaqSection from './components/FaqSection';
import MediaSection from './components/MediaSection';
import AppSection from './components/AppSection';
import AboutSection from './components/AboutSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import CardsSection from './components/CardsSection';
import IndexSection from './components/IndexSection';
import RankingSection from './components/RankingSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-950 text-foreground-100">
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <FeaturesSection />
        <UpdatesSection />
        <CommentsSection />
        <FaqSection />
        <MediaSection />
        <AppSection />
        <AboutSection />
        <CarouselSection />
        <ContactSection />
        <CardsSection />
        <IndexSection />
        <RankingSection />
      </main>
      <Footer />
    </div>
  );
}